import type {
  CalendarConversationCandidateType,
  CalendarConversationInviteeType,
  InviteContactType,
} from '@axiom/validation';
import { InterviewAttendeeResponses } from '@axiom/const';

type InviteeDisplay = {
  fullName: InviteContactType['fullName'];
  email: InviteContactType['email'];
  response: CalendarConversationInviteeType['attendeeResponse'];
};

export type SortAttendeesResult = {
  acceptedCount: number;
  contactInvitees: InviteeDisplay[];
  adhocInvitees: InviteeDisplay[];
  candidate: {
    calculatedDisplayName: CalendarConversationCandidateType['calculatedDisplayName'];
    email: CalendarConversationCandidateType['email'];
    response: CalendarConversationInviteeType['attendeeResponse'];
  } | null;
};

const sortAttendees = (
  invitees: CalendarConversationInviteeType[]
): SortAttendeesResult => {
  const inviteeData = invitees.reduce<SortAttendeesResult>(
    (acc, crnt) => {
      if (crnt.attendeeResponse === InterviewAttendeeResponses.ACCEPTED) {
        acc.acceptedCount += 1;
      }

      if (crnt.contact) {
        acc.contactInvitees.push({
          fullName: crnt.contact.fullName,
          email: crnt.contact.email,
          response: crnt.attendeeResponse,
        });
      } else if (crnt.adhocAttendee) {
        acc.adhocInvitees.push({
          fullName:
            `${crnt.adhocAttendee.firstName ?? ''} ${crnt.adhocAttendee.lastName ?? ''}`.trim(),
          email: crnt.adhocAttendee.email,
          response: crnt.attendeeResponse,
        });
      } else if (crnt.candidate) {
        acc.candidate = {
          calculatedDisplayName: crnt.candidate.calculatedDisplayName,
          email: crnt.candidate.email,
          response: crnt.attendeeResponse,
        };
      }

      return acc;
    },
    {
      acceptedCount: 0,
      contactInvitees: [],
      adhocInvitees: [],
      candidate: null,
    }
  );

  inviteeData.contactInvitees.sort((a, b) =>
    (a.fullName ?? '').localeCompare(b.fullName ?? '')
  );
  inviteeData.adhocInvitees.sort((a, b) =>
    (a.fullName ?? '').localeCompare(b.fullName ?? '')
  );

  return inviteeData;
};

export const InterviewGridAttendeesModalUtil = {
  sortAttendees,
};
